import moduleConfig from './module-config';
import netsDialer from './nets-dialer';

export default angular
  .module('app.dialer', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsDialer', netsDialer);
